require('./application/extra.js');

require('./application/jquery.js');
require('./application/bootstrap.js');

require('./application/coffee.js');
require('./application/vue.js');
